<template>
  <div class="card">
    <div class="card-body hm400">
      <h5 class="card-title text-center font-weight-bold">Recent Activity</h5>
      <div class="" v-if="loading">
        <div class="loader"></div>
      </div>
      <perfect-scrollbar class="scroll-area" v-else-if="!loading && recentActivityList.length">
        <div id="content">
          <ul class="timeline" >
            <li class="event" v-for="value in recentActivityList" :key="value.id">
              <small><b>{{ getTime(value.createdAt)}}</b></small>
              <p><img width="20px" class="rounded-circle mr-4" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(value.admin.email)}?s=50`">{{value.message}}</p>
            </li>
          </ul>
        </div>
      </perfect-scrollbar>
      <div v-else>  <p class="hm300 card-text text-center text-danger mb-3 font-weight-bold">No data found.</p></div>
    </div>
  </div>
</template>
<script>
import {db} from "@/firebase/init";
import moment from "moment/moment";
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
import md5 from "crypto-js/md5";

export default {
  name: "RecentActivity",
  components: {
    PerfectScrollbar
  },
  data () {
    return {
      recentActivityList: [],
      recentActivityListener: null,
      loading: true,
    }
  },
  mounted() {
    this.getRecentActivityPerDay();
  },
  methods: {
    emailHashGravatar(email) {
      if (!email) {
        return null
      } else {
        return md5(email.trim().toLowerCase()).toString()
      }
    },
    getTime(date){
      return moment(date).fromNow()
    },
    async getRecentActivityPerDay() {
      try {
        this.loading = true;
        this.recentActivityList = []
        const ref = await db.collection('recentActivity').where('createdAt', '>', moment().subtract(1, 'days').toISOString()).orderBy('createdAt', 'desc')
        this.recentActivityListener = ref.onSnapshot(querySnapshot => {
          querySnapshot.docChanges().forEach(changeDoc => {
            if (changeDoc.type === 'added'){
              if(this.recentActivityList.length > 50){
                this.recentActivityList.pop();
                this.recentActivityList.push({id: changeDoc.doc.id, ...changeDoc.doc.data()})
                this.recentActivityList.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt) );
              }
              else{
                this.recentActivityList.push({id: changeDoc.doc.id, ...changeDoc.doc.data()})
                this.recentActivityList.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt) );
              }
            }
          }); });

        console.log('recentActivity', this.recentActivityList)
      } catch (e) {
        console.log('error from recent activity', e.toString())
      } finally {
        this.loading = false;
      }
    }
  },
  destroyed() {
    this.recentActivityListener()
  }
}
</script>
<style scoped>
.scroll-area {
  position: relative;
  max-height: 350px;
  /*overflow: hidden;*/
}
.timeline {
  margin-left: 11px;
  border-left: 3px solid #727cf5;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  letter-spacing: 0.2px;
  position: relative;
  line-height: 1.4em;
  font-size: 1.03em;
  padding-left: 50px;
  list-style: none;
  text-align: left;
}
@media (max-width: 767px) {
  .timeline {
    max-width: 98%;
    padding: 25px;
  }
}
.timeline h1 {
  font-weight: 300;
  font-size: 1.4em;
}

.timeline h2,
.timeline h3 {
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 10px;
}

.timeline .event {
  border-bottom: 1px dashed #e8ebf1;
  padding-bottom: 10px;
  margin-bottom: 10px;
  position: relative;
}


.timeline .event:last-of-type {
  padding-bottom: 0;
  margin-bottom: 0;
  border: none;
}

.timeline .event:before,
.timeline .event:after {
  position: absolute;
  display: block;
  top: 0;
}

.timeline .event:before {
  left: -207px;
  content: attr(data-date);
  text-align: right;
  font-weight: 100;
  font-size: 0.9em;
  min-width: 120px;
}


.timeline .event:after {
  -webkit-box-shadow: 0 0 0 3px #727cf5;
  box-shadow: 0 0 0 3px #727cf5;
  left: -55.8px;
  background: #fff;
  border-radius: 50%;
  height: 9px;
  width: 9px;
  content: "";
  top: 5px;
}


.rtl .timeline {
  border-left: 0;
  text-align: right;
  border-radius: 4px 0 0 4px;
  border-right: 3px solid #727cf5;
}

.rtl .timeline .event::before {
  left: 0;
  right: -170px;
}

.rtl .timeline .event::after {
  left: 0;
  right: -55.8px;
}
</style>
